import { Popover, withStyles } from '@material-ui/core';

export const AntPopover = withStyles(theme => ({
    root: {},
    paper: {
        borderRadius: 20,
    },
}))(Popover);
